import {Component, forwardRef} from '@angular/core';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {EditorConfig} from "@ckeditor/ckeditor5-core";

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorComponent),
      multi: true
    }
  ]
})
export class EditorComponent implements ControlValueAccessor {
  public Editor = ClassicEditor;
  public editorValue: string | null = '';
  public editorConfig: EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'link',
        // 'insertImage',
        'mediaEmbed',
        // 'imageUpload',
        'bulletedList',
        'numberedList',
        '|',
        'alignment',
        'indent',
        'outdent',
        '|',
        'blockQuote',
        'insertTable',
        'undo',
        'redo',
        'code',
        'codeBlock'
      ]
    },
    language: 'en',
    image: {
      toolbar: [
        'imageTextAlternative',
        'imageStyle:inline',
        'imageStyle:block',
        'imageStyle:side'
      ]
    },
    table: {
      contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells'
      ]
    },
    licenseKey: '',
    placeholder: 'Type the content here!'
  };

  constructor() {
  }

  // Implement ControlValueAccessor interface
  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  writeValue(value: string): void {
    this.editorValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public onReady(editor: any) {
    editor.model.document.on('change:data', () => {
      this.onChange(editor.getData()); // Notify ngModel about changes
      this.onTouched();
    });
  }
}
